/**
 * /posvenda/* — router-shell do modulo Pos-venda (Fase 12).
 *
 * Sub-rotas:
 *   /posvenda/assistencias (default) -> Lista
 *   /posvenda/assistencias/kanban -> Kanban visual
 *   /posvenda/assistencias/criar -> Form nova assistencia
 *   /posvenda/assistencias/:id -> Detalhe + timeline + actions
 *   /posvenda/satisfacao -> Pesquisas de NPS respondidas (A27)
 *
 * As duas metades do modulo tem permissoes distintas (`assistencia:view` e
 * `satisfacao:view`), entao o shell entra com `requireAny` no App e cada
 * sub-rota se protege aqui dentro. Sem esta guarda, quem recebeu so o NPS
 * entraria tambem nas assistencias do cliente.
 */
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";
import { PageState } from "../../styles/shared";

import AssistenciasLista from "./Assistencias/Lista";
import AssistenciasKanban from "./Assistencias/Kanban";
import AssistenciaDetalhe from "./Assistencias/Detalhe";
import AssistenciaCriar from "./Assistencias/Criar";
import SatisfacaoLista from "./Satisfacao/Lista";

function Exige({ permissao, children }) {
  const { hasAllPermissions, isMaster } = useAuth();
  if (isMaster || hasAllPermissions([permissao])) return children;
  return (
    <PageState $tone="error">
      Você não tem permissão para acessar esta página.
    </PageState>
  );
}

export default function PosvendaShell() {
  const { hasAllPermissions, isMaster } = useAuth();
  // Quem so cuida do NPS cai direto na tela dele — mandar para assistencias
  // renderizaria "sem permissao" como pagina inicial do modulo.
  const inicial =
    isMaster || hasAllPermissions(["assistencia:view"])
      ? "assistencias"
      : "satisfacao";

  return (
    <Routes>
      <Route index element={<Navigate to={inicial} replace />} />
      <Route
        path="assistencias"
        element={<Exige permissao="assistencia:view"><AssistenciasLista /></Exige>}
      />
      <Route
        path="assistencias/kanban"
        element={<Exige permissao="assistencia:view"><AssistenciasKanban /></Exige>}
      />
      <Route
        path="assistencias/criar"
        element={<Exige permissao="assistencia:view"><AssistenciaCriar /></Exige>}
      />
      <Route
        path="assistencias/:id"
        element={<Exige permissao="assistencia:view"><AssistenciaDetalhe /></Exige>}
      />
      {/* A27 — as respostas de NPS, do outro lado do link publico. */}
      <Route
        path="satisfacao"
        element={<Exige permissao="satisfacao:view"><SatisfacaoLista /></Exige>}
      />
      <Route path="*" element={<Navigate to={inicial} replace />} />
    </Routes>
  );
}
